import backend, {LOOM_API} from 'utils/backend/loom/api_library';

import queryString from 'query-string';

import {
  adaptLoomJobDetail,
  adaptLoomJobList,
  toLoomJobListQuery,
} from './career_adapter';

const loomApi = () => {
  if (!LOOM_API) {
    throw new Error('REACT_APP_LOOM_API must be configured before Loom job reads can be enabled.');
  }

  return LOOM_API.replace(/\/$/, '');
};

const queryJob = async (filters, sort, lastEvaluatedKey) => {
  const query = queryString.stringify(
      toLoomJobListQuery(filters, sort, lastEvaluatedKey),
      {skipNull: true, skipEmptyString: true},
  );
  const response = await backend.get(`${loomApi()}/api/careos/jobs?${query}`);
  return adaptLoomJobList(response);
};

const getJob = async (jobRn) => {
  const response = await backend.get(`${loomApi()}/api/careos/jobs/${encodeURIComponent(jobRn)}`);
  return adaptLoomJobDetail(response);
};

export default {
  getJob,
  queryJob,
};
